// RS2-routes — native recompose of the `/error` route's default render of
// src/components/common/errorPages/Error.tsx (antd Result status="error" +
// Go Home). The route mounts it prop-less, so only the default branch is
// ported: home button shown, no refresh, no auto-redirect.
import { CloseCircleBold } from '@assessprep/icons/solar';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { APStatusView } from '@/components/ap/status/APStatusView';
import { Button } from '@/components/ui/button';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <APStatusView
      fullScreen
      tone="danger"
      icon={<CloseCircleBold />}
      title={t('CommonText.an_error_occurred')}
      description={t('Error.sorry_something_went_wrong')}
      testId="v4-error-page"
      actions={
        <Button onClick={() => navigate('/')} data-testid="v4-error-go-home">
          {t('Error.go_home')}
        </Button>
      }
    />
  );
};
